module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-04-15 at 18.48.35.jpeg";